import { memo } from "react";
import styled from "styled-components";
import Tippy from '@tippyjs/react/headless';
import IconPanel from "./IconPanel";
import { useRef } from "react";
import { useState } from "react";
import { Icon } from "./svg/shapes";

export interface IconSelectorProps {
  value: string;
  color: string;
  onChange: (icon: string) => void;
}
const IconSelector = (props: IconSelectorProps) => {
  const tippyRef = useRef<any>(null);
  return (
    <Tippy
      trigger="click"
      interactive
      offset={[0, 24]}
      placement="left-start"
      delay={0}
      ref={tippyRef}
      render={(attrs) => (
        <IconPanel onClose={() => {
          tippyRef.current.hide();
        }} onIconSelect={(icon) => {
          props.onChange(icon);
        }} />
      )}
    >
      <UI_Wrapper>
        {
          !props.value && (<div style={{ color: '#aaa', fontSize: 12 }}>Chưa chọn icon</div>)
        }
        {props.value && (
          <UI_Content><Icon icon={props.value} size={18} fill={props.color} /> {props.value} </UI_Content>
        )}
      </UI_Wrapper>
    </Tippy>);
};

export default memo(IconSelector);

const UI_Wrapper = styled.div`
  width: 100%;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const UI_Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
`;